import { FC, Suspense } from 'react';
import { useSelector } from 'react-redux';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { lazy } from 'utils/generic/lazy';
import { USER_ACTIVE_STEP_STATES_TO_SHOW_STATUS_BAR } from 'components/Generic/__partials/KYCVerificationStatusBar/constants';
import { useFetchAccountParams } from 'newhooks/account/useFetchAccountParams';
import { getIsLoggedIn, getUser } from 'store/selectors/user-data';

const { KYCVerificationStatusBarComponent } = lazy(
  () =>
    import(
      /* webpackChunkName: "KYCVerificationStatusBarComponent" */ './Component'
    )
);

export const KYCVerificationStatusBar: FC = () => {
  const user = useSelector(getUser);

  const isLoggedIn = useSelector(getIsLoggedIn);
  const { accountParams } = useFetchAccountParams();

  if (user.pending || !isLoggedIn) {
    return;
  }

  const shouldShowKycVerificationStatusBar =
    user.active_step_state !== null &&
    (SpringConfigs.SHOW_KYC_STATUS_BAR ||
      Boolean(+accountParams?.verificationKYCStatus)) &&
    USER_ACTIVE_STEP_STATES_TO_SHOW_STATUS_BAR.includes(user.active_step_state);

  return shouldShowKycVerificationStatusBar ? (
    <Suspense>
      <KYCVerificationStatusBarComponent />
    </Suspense>
  ) : null;
};
